<template>
  <div>
    <div class="flex items-center justify-between">
      <div>
        <p class="mb-0">
          <a
            :href="`/subject-areas/listing/${contentListing.subjectAreaId}`"
            class="underline"
            >Back to {{ contentListing.subjectAreaName }}</a
          >
        </p>
        <h2 class="mb-5 mt-0">Edit Content Listing</h2>
      </div>
      <d-btn @click="gotoCoursePreview"> Preview Course </d-btn>
    </div>
    <d-tabs :tabs="tabs">
      <template #tab-content="{ currentTab }">
        <listing-info-tab v-if="currentTab.label === 'Lesson Info'" class="bg-white rounded shadow px-5 py-8 mt-3" />
        <files-tab v-if="currentTab.label === 'Files'" />
        <assets-tab v-if="currentTab.label === 'Assets'" />
        <static-organization-tab
          v-if="currentTab.label === 'Organization' && newContentListing.type === ContentListingType.STATIC"
        />
        <interactive-organization-tab
          v-if="currentTab.label === 'Organization' && newContentListing.type === ContentListingType.INTERACTIVE"
        />
      </template>
    </d-tabs>
  </div>
</template>

<script>
import axios from "axios";
import { markRaw } from "vue";
import { ContentListingType } from "@resources/scripts/constants";
import ListingInfoTab from "./components/ListingInfoTab.vue";
import FilesTab from "./components/FilesTab.vue";
import AssetsTab from "./components/AssetsTab.vue";
import StaticOrganizationTab from "./components/StaticOrganizationTab.vue";
import InteractiveOrganizationTab from "./components/InteractiveOrganizationTab.vue";

export default {
  name: 'EditContentListingPage',
  components: {
    ListingInfoTab,
    FilesTab,
    AssetsTab,
    StaticOrganizationTab,
    InteractiveOrganizationTab,
  },

  provide() {
    return {
      contentListing: this.newContentListing,
      getContentListingInfo: () => this.getContentListingInfo(),
    };
  },

  props: {
    contentListing: {
      type: Object,
      default: () => ({}),
    },
    contentLibraryUrl: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      ContentListingType,
      activeTab: 0,
      newContentListing: this.contentListing,
    };
  },

  computed: {
    tabs() {
      return [
        {
          label: "Lesson Info",
          component: markRaw(ListingInfoTab),
        },
        {
          label: "Files",
          component: markRaw(FilesTab),
        },
        {
          label: "Assets",
          component: markRaw(AssetsTab),
        },
        {
          label: "Organization",
          component: this.newContentListing.type === ContentListingType.STATIC
            ? markRaw(StaticOrganizationTab)
            : this.newContentListing.type === ContentListingType.INTERACTIVE
            ? markRaw(InteractiveOrganizationTab)
            : null,
        },
      ];
    },
  },

  methods: {
    async getContentListingInfo() {
      const { data } = await axios.get(
        `/api/content-listings/${this.contentListing.id}`
      );
      this.newContentListing = data;
    },

    gotoCoursePreview() {
      window.open(
        `${this.contentLibraryUrl}content/${this.contentListing.id}`,
        "_blank"
      ) ||
        window.location.replace(
          `${this.contentLibraryUrl}content/${this.contentListing.id}`
        );
    },
  },
};
</script>
